import React from 'react'
import Topdistn from './Partials/Topdistn'


export const DistributorReport = () => {
  return (
    <Topdistn />
  )
}
